<div class="cm-benefit">
  <svg-icon src="{{ icon }}" class="cm-benefit-icon"></svg-icon>
  <h3>{{ heading | translate }}</h3>
  <p class="cm-paragraph" [innerHTML]="text | translate"></p>
</div>
